var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusniessImg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 208,
    viewBox: "0 0 320 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2150_627)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2150_627)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 312,
    height: 200,
    rx: 24,
    fill: "url(#paint0_linear_2150_627)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.31 136.092C208.125 128.428 227.704 96.4232 220.04 64.6074C212.375 32.7917 180.37 13.2131 148.555 20.8774C116.739 28.5417 97.1604 60.5466 104.825 92.3624C112.489 124.178 144.494 143.757 176.31 136.092Z",
    fill: "#E7E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.091 130.524C206.833 121.87 223.118 91.5539 214.464 62.8112C205.809 34.0686 175.493 17.7839 146.751 26.4382C118.008 35.0925 101.723 65.4086 110.378 94.1512C119.032 122.894 149.348 139.179 178.091 130.524Z",
    fill: "#E7E3FF",
    stroke: "#464068",
    strokeOpacity: 0.25,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.283 133.738C176.132 133.738 185.738 109.21 185.738 78.9535C185.738 48.6968 176.132 24.1689 164.283 24.1689C152.434 24.1689 142.828 48.6968 142.828 78.9535C142.828 109.21 152.434 133.738 164.283 133.738Z",
    fill: "#E7E3FF",
    stroke: "#464068",
    strokeOpacity: 0.25,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.78 78.4905H108.074",
    stroke: "#464068",
    strokeOpacity: 0.25,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.973 105.228C178.961 105.228 193.335 108.736 203.281 114.319C193.319 125.668 178.715 132.843 162.426 132.843C146.34 132.843 131.892 125.85 121.941 114.745C131.906 108.917 146.587 105.228 162.973 105.228Z",
    fill: "#E7E3FF",
    stroke: "#464068",
    strokeOpacity: 0.25,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.11 43.6198C194.144 49.4818 179.417 53.1973 162.974 53.1973C146.132 53.1973 131.081 49.3043 121.111 43.1937C131.081 31.5356 145.885 24.1375 162.427 24.1375C179.171 24.1381 194.14 31.7144 204.11 43.6198Z",
    fill: "#E7E3FF",
    stroke: "#464068",
    strokeOpacity: 0.25,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.326 86.5964L251.636 89.5431L229.946 92.4899C227.588 92.8105 226.461 95.5637 227.917 97.4453L236.539 108.587L203.074 136.066C201.028 137.747 198.08 137.752 196.027 136.079L182.879 125.365C181.014 123.845 178.385 123.696 176.36 124.994L128.841 155.458C127.292 156.451 125.352 156.614 123.659 155.894L111.943 150.909C110.246 150.187 108.301 150.352 106.751 151.351L58.7612 182.258C54.9992 184.681 53.9133 189.695 56.3365 193.457C57.7498 195.651 60.044 196.934 62.4579 197.143C64.1823 197.291 65.9678 196.891 67.5363 195.881L108.307 169.623C109.858 168.624 111.803 168.459 113.499 169.181L125.195 174.158C126.889 174.878 128.828 174.715 130.377 173.722L175.224 144.971C177.249 143.674 179.878 143.823 181.742 145.342L196.067 157.015C198.12 158.687 201.067 158.682 203.114 157.001L246.462 121.407L254.711 132.067C256.168 133.949 259.115 133.549 260.017 131.346L268.31 111.089L276.604 90.8314C277.505 88.6285 275.684 86.2758 273.326 86.5964Z",
    fill: "#E0DAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5692 116.708C71.6305 116.708 79.7868 108.552 79.7868 98.4906C79.7868 88.4292 71.6305 80.2729 61.5692 80.2729C51.5079 80.2729 43.3516 88.4292 43.3516 98.4906C43.3516 108.552 51.5079 116.708 61.5692 116.708Z",
    fill: "#917EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5687 118.665C72.7112 118.665 81.7439 109.633 81.7439 98.4901C81.7439 87.3477 72.7112 78.3149 61.5687 78.3149C50.4263 78.3149 41.3936 87.3477 41.3936 98.4901C41.3936 109.633 50.4263 118.665 61.5687 118.665Z",
    stroke: "#917EFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9315 87.4303C65.1416 85.1549 69.841 91.201 69.1676 96.0112C68.8746 100.754 63.3252 103.685 63.8292 105.475C62.6827 105.475 60.3764 105.475 59.2306 105.475C59.2306 105.475 59.5572 104.594 58.359 103.535C53.8363 99.9707 50.9225 91.0289 58.9315 87.4303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8296 105.475C63.8041 107.65 64.3578 110.272 61.196 110.03C58.7129 109.948 59.2747 107.145 59.2277 105.475H63.8296Z",
    fill: "#715DE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4505 105.475C62.4505 105.475 62.3672 98.2384 63.005 96.2311C63.6427 94.2244 64.9175 92.6748 65.8597 94.3999C67.6728 99.8842 57.944 101.26 57.1853 96.4065C56.182 91.7259 61.4472 91.3274 60.5682 105.475",
    stroke: "#917EFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3123 50.5436C98.3736 50.5436 106.53 42.3873 106.53 32.326C106.53 22.2647 98.3736 14.1084 88.3123 14.1084C78.251 14.1084 70.0947 22.2647 70.0947 32.326C70.0947 42.3873 78.251 50.5436 88.3123 50.5436Z",
    fill: "#917EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3124 52.501C99.4548 52.501 108.488 43.4683 108.488 32.3258C108.488 21.1834 99.4548 12.1506 88.3124 12.1506C77.17 12.1506 68.1372 21.1834 68.1372 32.3258C68.1372 43.4683 77.17 52.501 88.3124 52.501Z",
    stroke: "#917EFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3231 41.5004C97.6103 39.2862 100.101 33.2051 97.8871 27.918C95.6728 22.6309 89.5918 20.1398 84.3046 22.354C79.0175 24.5683 76.5264 30.6493 78.7407 35.9365C80.9549 41.2236 87.036 43.7147 92.3231 41.5004Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8871 36.8211C85.377 37.2935 84.5571 37.1537 84.2326 36.5395L82.1802 32.658C81.9114 32.1513 82.105 31.523 82.6117 31.2555C83.1211 30.9867 83.7467 31.1802 84.0142 31.6869L85.4482 34.3985L92.8222 27.5715C93.2416 27.1797 93.8995 27.2059 94.2886 27.6273C94.679 28.048 94.6535 28.7045 94.2328 29.0936L85.8871 36.8211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7583 42.4326C99.3852 39.7857 97.7477 37.1317 95.1008 36.5047C92.4539 35.8777 89.7998 37.5152 89.1729 40.1621C88.5459 42.8091 90.1834 45.4631 92.8303 46.0901C95.4772 46.7171 98.1313 45.0796 98.7583 42.4326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1542 41.2963C98.1542 43.6128 96.2766 45.4904 93.9602 45.4904C91.6437 45.4904 89.7661 43.6128 89.7661 41.2963C89.7661 38.9799 91.6437 37.1023 93.9602 37.1023C96.2766 37.1023 98.1542 38.9799 98.1542 41.2963Z",
    fill: "#917EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2402 41.9618C95.2335 42.5814 94.7348 42.8522 94.124 42.9093V43.4328H93.7739V42.9194C93.3585 42.9107 92.9943 42.8374 92.6812 42.6996V42.0256C92.8142 42.1016 93.5366 42.3334 93.7739 42.3193V41.5277C92.4184 41.2824 92.286 39.6117 93.7739 39.5513V39.1602H94.124V39.5405C94.5137 39.5573 94.8665 39.6359 95.181 39.7757L94.9411 40.3731C94.6757 40.2643 94.4029 40.1977 94.124 40.1742V40.9275C94.7362 41.1869 95.2093 41.32 95.2402 41.9618ZM93.4452 40.4497C93.454 40.6446 93.5897 40.6923 93.7745 40.7844V40.1843C93.5548 40.2166 93.4452 40.3053 93.4452 40.4497ZM94.4714 42.0001C94.46 41.8099 94.3027 41.7588 94.124 41.6654V42.3011C94.3558 42.2622 94.4714 42.162 94.4714 42.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.997 62.2381C266.336 52.4525 260.298 42.6241 250.513 40.2859C240.727 37.9476 230.899 43.9849 228.56 53.7706C226.222 63.5562 232.259 73.3845 242.045 75.7228C251.831 78.061 261.659 72.0237 263.997 62.2381Z",
    fill: "#917EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.292 78.1841C257.435 78.1841 266.468 69.1514 266.468 58.0089C266.468 46.8665 257.435 37.8337 246.292 37.8337C235.15 37.8337 226.117 46.8665 226.117 58.0089C226.117 69.1514 235.15 78.1841 246.292 78.1841Z",
    stroke: "#917EFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.019 60.2581C239.019 60.2581 239.258 63.6726 239.279 65.1248C239.289 65.8116 239.386 66.3298 239.486 66.6853C239.582 67.0266 239.921 67.239 240.271 67.1792L242.203 66.8512C242.6 66.7834 242.857 66.3943 242.762 66.0025C242.408 64.5449 241.672 61.295 241.845 60.1311L239.019 60.2581Z",
    fill: "#715DE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.224 56.0224L237.625 59.8206C237.655 60.1055 237.901 60.3179 238.187 60.3071L243.265 60.1156L242.958 54.761L237.89 55.2139C237.481 55.2495 237.181 55.6144 237.224 56.0224Z",
    fill: "#715DE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.958 54.7605L251.859 49.0215C252.54 48.5833 253.449 48.928 253.665 49.7076C254.386 52.317 255.602 57.8524 254.822 63.3831C254.748 63.9106 254.199 64.2311 253.701 64.0436L243.265 60.1157L242.958 54.7605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.251 56.282C236.639 56.3297 236.187 56.8734 236.252 57.4842L236.373 58.6166C236.438 59.2267 236.992 59.6635 237.6 59.5849L237.251 56.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.614 54.0925C254.614 54.0925 256.349 54.661 256.339 56.1227C256.329 57.5843 255.074 58.552 255.074 58.552C255.074 58.552 254.741 54.9507 254.614 54.0925Z",
    fill: "#715DE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.822 63.3831C255.602 57.8531 254.385 52.317 253.664 49.7076C253.448 48.928 252.539 48.5833 251.859 49.0215L251.601 49.1874C251.928 49.9125 252.553 51.5563 252.9 54.1617C253.348 57.5238 253.712 61.2568 253.237 63.8682L253.7 64.0423C254.199 64.2311 254.748 63.9106 254.822 63.3831Z",
    fill: "#715DE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.281 143.324L118.337 142.498C118.514 141.377 118.581 139.568 117.682 137.864C116.792 136.181 115.202 135.007 112.956 134.376C109.105 133.295 106.667 134.85 105.301 136.345C104.653 137.056 104.19 137.814 103.876 138.439L100.825 137.583C99.9148 137.327 98.97 137.858 98.7146 138.768L95.1993 151.291C94.944 152.201 95.4749 153.146 96.3848 153.401L116.841 159.143C117.751 159.398 118.696 158.868 118.951 157.957L122.466 145.434C122.722 144.524 122.191 143.58 121.281 143.324ZM112.333 136.595C113.94 137.046 115.051 137.829 115.635 138.924C116.182 139.947 116.191 141.082 116.098 141.869L106.127 139.07C106.965 137.591 108.793 135.601 112.333 136.595Z",
    fill: "#A0C8EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.506 119.862L114.382 131.79C114.382 131.79 115.583 132.828 116.086 134.087C116.59 135.347 116.427 136.377 116.135 136.06C115.956 135.865 115.686 135.667 115.305 135.41C114.791 135.064 114.552 134.66 114.173 134.681C113.518 134.716 112.817 135.002 113.343 136.361C113.853 137.678 115.666 138.062 115.207 138.401C114.038 139.264 113.212 138.078 113.212 138.078C113.212 138.078 112.869 138.609 112.404 138.6C111.939 138.591 111.76 137.773 111.76 137.773C111.76 137.773 111.411 138.231 110.882 138.156C110.353 138.082 110.238 137.331 110.238 137.331C110.238 137.331 109.406 138.074 108.865 137.174C108.324 136.274 107.259 134.005 110.518 131.102C110.518 131.102 113.571 115.907 114.954 115.096C116.338 114.284 117.506 119.862 117.506 119.862Z",
    fill: "#E1B39D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.682 129.645L114.566 131.198C114.742 131.268 114.939 131.17 114.99 130.987L115.099 130.592C115.141 130.437 115.062 130.276 114.914 130.215L111.045 128.623C110.87 128.551 110.671 128.647 110.62 128.829L110.495 129.264C110.45 129.42 110.531 129.585 110.682 129.645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.51 129.104L115.085 130.751C115.293 130.826 115.523 130.718 115.598 130.51L117.872 118.95L123.487 112.266C123.562 112.058 122.897 109.711 122.689 109.636L121.195 104.163C120.987 104.087 112.576 116.535 112.576 116.535L110.269 128.59C110.193 128.799 110.301 129.029 110.51 129.104Z",
    fill: "#264154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.306 124.747C158.306 124.747 161.2 126.314 161.32 126.291C161.44 126.267 163.56 125.629 164 126.174C164.441 126.718 166.261 128.729 167.413 129.887C168.565 131.045 169.28 132.522 168.572 133.068C167.865 133.614 167.67 133.113 167.67 133.113C167.67 133.113 168.125 134.105 167.389 134.372C166.652 134.638 166.308 134.249 166.308 134.249C166.308 134.249 166.503 134.862 166.068 135.107C165.632 135.352 165.07 135.133 164.902 134.888C164.902 134.888 164.263 135.829 163.447 135.282C162.63 134.736 158.771 131.68 158.688 130.343L157.057 129.277L158.306 124.747Z",
    fill: "#E1B39D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.181 125.134L157.298 129.477C157.216 129.664 156.993 129.742 156.814 129.646L154.174 128.235C154.014 128.15 153.946 127.956 154.019 127.789L155.993 123.245C156.078 123.049 156.318 122.975 156.499 123.089L159.047 124.701C159.193 124.792 159.25 124.976 159.181 125.134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.923 189.906L138.788 194.263L133.169 194.236L133.19 189.878L138.923 189.906Z",
    fill: "#F3D6C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.169 194.236L138.666 194.263C138.749 194.264 138.828 194.273 138.91 194.292C139.694 194.48 144.161 195.607 148.095 197.782C149.072 198.323 148.672 199.818 147.554 199.812L134.228 199.746C133.629 199.744 133.146 199.255 133.148 198.656L133.169 194.236Z",
    fill: "#2F526E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.855 82.9263C135.855 82.9263 136.126 84.5505 138.133 87.8945C140.182 91.3083 140.002 96.6078 137.328 97.843C135.246 98.8046 133.677 98.4498 133.677 98.4498L132.702 106.089L125.912 104.621L126.323 97.1447L124.151 86.5014L135.855 82.9263Z",
    fill: "#E1B39D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.941 189.575L127.821 194.264L122.201 194.236L122.223 189.878L127.941 189.575Z",
    fill: "#F3D6C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.201 194.236L127.697 194.263C127.78 194.264 127.86 194.273 127.941 194.292C128.725 194.48 133.192 195.607 137.126 197.782C138.104 198.323 137.703 199.818 136.586 199.812L123.259 199.746C122.66 199.744 122.176 199.255 122.18 198.656L122.201 194.236Z",
    fill: "#315780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.303 137.001L139.999 189.911C140.007 190.497 139.54 190.979 138.953 190.991L133.015 191.106C132.446 191.116 131.968 190.678 131.931 190.108L130.706 171.198L128.772 190.358C128.718 190.896 128.27 191.308 127.731 191.317L122.537 191.41C121.955 191.42 121.474 190.963 121.452 190.383L119.513 137.001C119.51 136.714 139.303 137.001 139.303 137.001Z",
    fill: "#917EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.923 189.906L132.973 189.983",
    stroke: "#715DE3",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.878 190.075L122.123 190.164",
    stroke: "#715DE3",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.782 188.597L132.359 154.122",
    stroke: "#715DE3",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.671 137.68C135.671 137.68 135.75 144.648 133.489 145.654C131.229 146.658 134.077 140.422 133.113 137.637L135.671 137.68Z",
    stroke: "#715DE3",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.49 145.654L133.049 147.001L130.706 171.199",
    stroke: "#715DE3",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.967 136.564L123.329 188.597",
    stroke: "#715DE3",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.794 108.303C120.11 105.342 121.215 101.978 124.916 101.372C127.548 100.94 131.352 101.045 133.902 101.794C136.325 102.507 138.429 104.025 139.85 106.114C142.175 109.533 145.73 114.766 145.747 114.78L158.616 123.709C158.865 123.9 158.948 124.238 158.817 124.523L156.7 129.139C156.521 129.527 156.036 129.656 155.692 129.404C152.817 127.297 141.322 120.06 141.306 120.042L139.209 118.044L139.648 137.747H119.139C119.139 137.747 119.091 114.891 119.794 108.303Z",
    fill: "#315782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.245 96.4332L128.076 94.1101C128.29 93.8392 128.214 93.4454 127.916 93.2714C127.191 92.8467 126.056 91.9778 126.099 90.7177C126.163 88.8724 128.164 88.1426 129.67 89.6654C129.67 89.6654 130.005 90.6754 130.434 86.767C130.862 82.8585 134.19 85.7025 135.735 84.0715C137.279 82.4406 138.299 81.5112 137.97 79.9911C137.64 78.4716 136.65 76.3004 134.69 77.6189C132.729 78.9374 132.587 76.3676 130.444 77.4717C127.774 78.8473 124.833 76.0215 124.532 79.3217C124.231 82.622 120.382 80.3802 121.439 83.0467C122.497 85.7133 118.298 85.7146 119.294 87.5976C120.29 89.4812 118.983 91.84 120.767 92.7546C122.551 93.6692 123.939 92.758 124.124 95.2323C124.231 96.6765 126.245 96.4332 126.245 96.4332Z",
    fill: "#2F5482"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.483 105.019C134.483 105.019 130.277 106.965 134.82 112.742C139.143 118.239 139.209 118.043 139.209 118.043",
    stroke: "#264154",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.896 125.503C125.896 125.503 126.295 133.119 132.593 134.016",
    stroke: "#264154",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.53 121.163C122.53 121.163 121.832 132.22 125.557 134.733",
    stroke: "#264154",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.602 190.972L187.749 195.739L192.82 194.899L192.801 190.947L187.602 190.972Z",
    fill: "#E1B39D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.82 194.899C187.577 194.819 185.86 194.813 179.283 198.116C178.396 198.606 178.759 199.962 179.773 199.957L191.861 199.897C193.615 199.998 192.82 194.899 192.82 194.899Z",
    fill: "#2F526E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.195 190.947L211.317 195.731L216.406 196.118L216.381 191.221L211.195 190.947Z",
    fill: "#E1B39D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.513 194.879C212.851 194.882 210.744 195.02 209.652 196.104C208.243 197.503 208.431 199.925 209.004 199.927L217.971 199.957C218.404 199.991 218.261 197.868 217.258 196.518C216.356 195.301 215.604 194.869 213.513 194.879Z",
    fill: "#315780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.049 148.025L216.951 147.295C216.808 146.194 216.791 144.424 217.717 142.78C218.631 141.157 220.218 140.051 222.433 139.495C226.229 138.541 228.572 140.127 229.868 141.626C230.484 142.338 230.915 143.092 231.206 143.712L234.213 142.956C235.11 142.73 236.02 143.275 236.246 144.172L239.349 156.516C239.575 157.413 239.031 158.323 238.134 158.549L217.97 163.618C217.073 163.843 216.163 163.298 215.937 162.402L212.834 150.057C212.608 149.16 213.152 148.25 214.049 148.025ZM222.983 141.682C221.398 142.08 220.29 142.817 219.69 143.872C219.129 144.858 219.089 145.968 219.158 146.74L228.987 144.269C228.207 142.799 226.472 140.805 222.983 141.682Z",
    fill: "#EBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.991 131.804C212.531 135.485 214.87 152.268 214.61 165.405C214.609 165.445 214.611 165.484 214.615 165.523L217.67 191.706C217.734 192.255 217.305 192.738 216.752 192.738H210.797C210.366 192.738 209.993 192.442 209.896 192.023C208.863 187.575 203.353 163.773 202.941 160.616C202.486 157.131 202.031 152.433 202.031 152.433L198.251 167.857C198.246 167.878 198.242 167.899 198.238 167.92L194.038 192.308C193.961 192.757 193.568 193.083 193.112 193.076L186.866 192.977C186.336 192.968 185.921 192.516 185.959 191.987L187.937 164.288C187.939 164.265 187.941 164.24 187.945 164.217L192.966 130.697C193.037 130.222 193.46 129.88 193.94 129.911L211.137 131.021C211.572 131.049 211.928 131.372 211.991 131.804Z",
    fill: "#315782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.041 152.433L199.689 133.737",
    stroke: "#264154",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.52 150.955L195.449 167.585L192.009 190.947",
    stroke: "#264154",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.864 139.154L212.546 165.286L215.997 190.947",
    stroke: "#264154",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.127 135.107C197.127 135.107 198.027 141.431 200.52 141.343",
    stroke: "#264154",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.198 133.737C206.198 133.737 207.148 137.832 210.086 141.344",
    stroke: "#264154",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.783 125.593L221.545 137.031C221.545 137.031 219.903 137.91 219.377 139.128C218.851 140.347 218.983 141.359 219.278 141.056C219.458 140.871 219.727 140.684 220.106 140.443C220.619 140.118 220.864 139.73 221.233 139.76C221.873 139.812 222.551 140.111 222 141.425C221.466 142.701 219.682 143.027 220.122 143.371C221.242 144.246 222.083 143.109 222.083 143.109C222.083 143.109 222.405 143.637 222.86 143.64C223.315 143.644 223.511 142.848 223.511 142.848C223.511 142.848 223.84 143.306 224.36 143.247C224.88 143.189 225.012 142.457 225.012 142.457C225.012 142.457 225.806 143.205 226.359 142.34C226.913 141.474 228.016 139.283 224.905 136.356C224.905 136.356 222.325 121.411 220.994 120.58C219.662 119.751 217.783 125.593 217.783 125.593Z",
    fill: "#F3D6C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.8 132.195C168.8 132.195 168.781 131.7 167.706 130.551C166.631 129.401 165.477 127.777 164.62 127.9C164.62 127.9 164.114 130.115 163.31 130.307C162.505 130.5 162.53 129.248 162.427 128.26C162.324 127.271 163.577 126.005 164.433 125.853C165.386 125.684 166.418 126.707 167.676 126.829L171.744 125.502L172.926 130.329L170.545 131.075C170.545 131.075 169.855 131.535 168.8 132.195Z",
    fill: "#F3D6C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.567 126.023L171.963 130.408C172.026 130.606 172.248 130.705 172.437 130.62L172.85 130.435C173.011 130.363 173.093 130.183 173.041 130.015L171.688 125.616C171.627 125.417 171.407 125.316 171.216 125.399L170.759 125.598C170.596 125.669 170.513 125.853 170.567 126.023Z",
    fill: "#F9ECDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.143 128.419L162.427 128.26C162.483 128.799 162.501 129.416 162.637 129.834C163.243 130.133 163.341 129.131 163.355 128.678C163.359 128.556 163.269 128.447 163.143 128.419Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.215 132.115C161.215 132.115 162.337 131.419 162.816 131.67C163.296 131.921 163.324 132.243 163.199 132.426C163.199 132.426 163.851 132.193 164.209 132.712C164.567 133.232 163.511 133.972 163.511 133.972C163.511 133.972 164.289 134.079 163.555 134.917C162.821 135.756 161.9 135.495 161.983 134.879C161.983 134.879 161.215 134.988 160.936 134.576C160.657 134.164 160.89 133.834 160.89 133.834C160.89 133.834 160.135 133.945 159.978 133.485C159.821 133.026 160.057 132.794 160.057 132.794C160.057 132.794 159.01 132.712 159.18 132.02C159.35 131.327 160.86 130.884 161.102 131.157C161.345 131.43 161.462 131.542 161.215 132.115Z",
    fill: "#F3D6C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.244 132.088L160.086 131.839C160.023 131.741 160.056 131.614 160.16 131.557L160.513 131.36C160.685 131.264 160.91 131.319 161.014 131.483C161.118 131.647 161.063 131.858 160.89 131.954L160.526 132.158C160.429 132.212 160.303 132.181 160.244 132.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.069 132.584L161.91 132.335C161.848 132.237 161.88 132.11 161.984 132.053L162.337 131.856C162.509 131.76 162.734 131.815 162.838 131.979C162.942 132.143 162.887 132.354 162.714 132.45L162.35 132.653C162.253 132.707 162.127 132.676 162.069 132.584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.155 133.414L162.996 133.165C162.933 133.066 162.966 132.94 163.07 132.882L163.423 132.685C163.595 132.589 163.82 132.644 163.924 132.808C164.028 132.972 163.973 133.184 163.8 133.28L163.436 133.483C163.339 133.538 163.213 133.507 163.155 133.414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.264 134.712L163.097 134.515C163.073 134.485 163.077 134.443 163.108 134.42L163.384 134.213C163.47 134.149 163.595 134.163 163.664 134.245C163.733 134.326 163.72 134.444 163.634 134.508L163.349 134.722C163.323 134.741 163.285 134.737 163.264 134.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.841 136.51L225.314 135.433C225.516 135.384 225.631 135.17 225.56 134.974L225.405 134.55C225.345 134.384 225.171 134.29 224.999 134.329L220.515 135.362C220.312 135.408 220.195 135.621 220.264 135.817L220.429 136.286C220.49 136.456 220.667 136.552 220.841 136.51Z",
    fill: "#F9ECDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.764 131.869C210.323 132.462 201.324 135.828 193.053 131.204C192.951 131.147 192.885 131.044 192.881 130.927C192.813 129.256 192.536 115.701 192.397 112.234L186.371 120.868C186.353 120.889 173.3 130.615 173.3 130.615C173.115 130.752 172.851 130.668 172.779 130.449L171.004 125.048C170.96 124.917 171.002 124.771 171.109 124.683L181.584 116.084C181.611 116.062 189.577 101.777 191.672 100.903C194.423 99.7557 197.339 98.2363 200.119 98.5649C205.979 99.257 200.546 96.485 213.486 100.025C218.605 101.426 224.691 127.893 225.661 134.258C225.686 134.428 225.579 134.587 225.414 134.631L220.375 135.987C220.201 136.034 220.021 135.936 219.967 135.764L212.594 112.683L211.97 131.569C211.966 131.701 211.886 131.819 211.764 131.869Z",
    fill: "#917EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.467 80.8359C196.467 80.8359 196.24 82.4542 194.335 85.8223C192.39 89.261 192.705 94.5134 195.39 95.67C197.48 96.5698 199.027 96.178 199.027 96.178L199.854 101.803L206.807 99.4608L206.288 94.6935L208.169 84.0798L196.467 80.8359Z",
    fill: "#F3D6C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.73 77.4885C194.7 76.9603 195.221 76.5578 195.719 76.7372C196.751 77.1095 198.773 77.5046 202.469 77.1928C209.529 76.5961 212.847 82.8397 212.581 87.2347C212.353 91.002 208.217 92.932 206.868 94.4508C206.577 94.7787 206.059 94.7599 205.767 94.4326C205.079 93.6598 204.12 92.5073 204.108 92.0698C204.088 91.3871 206.083 91.3783 206.287 89.3421C206.49 87.3053 203.781 86.9115 202.919 88.4437C202.058 89.9758 202.689 84.5493 201.248 83.9546C199.922 83.4069 194.992 82.0226 194.73 77.4885Z",
    fill: "#2F5482"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.793 98.9734C206.793 98.9734 207.33 103.384 202.88 103.781C198.429 104.178 199.616 99.3443 199.616 99.3443L206.793 98.9734Z",
    fill: "#F3D6C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.907 104.522L202.752 107.558C202.547 107.847 202.121 107.855 201.905 107.573L199.217 104.059C199.217 104.059 202.739 103.248 204.907 104.522Z",
    fill: "#F9ECDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.276 106.605L205.254 123.52C205.29 123.722 205.267 123.934 205.189 124.118L202.908 129.491C202.64 130.122 201.906 130.126 201.634 129.498L199.341 124.206C199.261 124.02 199.237 123.806 199.273 123.601L202.276 106.605Z",
    fill: "#F9ECDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.678 98.2725C206.678 98.2725 204.457 103.406 201.505 103.714L205.73 106.231C205.73 106.231 210.424 100.106 206.678 98.2725Z",
    fill: "#715DE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.38 98.4902C199.38 98.4902 199.691 102.906 202.173 103.879L198.742 106.231C198.742 106.231 195.724 99.38 199.38 98.4902Z",
    fill: "#715DE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.745 200H37",
    stroke: "#315782",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2150_627",
    x: 0,
    y: 0,
    width: 320,
    height: 208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2150_627"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2150_627",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2150_627",
    x1: 160,
    y1: 0,
    x2: 160,
    y2: 200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBE8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2150_627"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 312,
    height: 200,
    rx: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusniessImg2);
export default __webpack_public_path__ + "static/media/busniess-Img2.40adcfc8510385338b5a3cc61e2e4d42.svg";
export { ForwardRef as ReactComponent };